import { render, staticRenderFns } from "./ShippingModal.vue?vue&type=template&id=171d8c44&scoped=true&"
import script from "./ShippingModal.vue?vue&type=script&lang=js&"
export * from "./ShippingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171d8c44",
  null
  
)

export default component.exports